module.exports = __webpack_public_path__ + "img/image7.1a99845c.jpg";